import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { blueMui, ScreenDepth } from "@ryde/theme";

export const RideStartEndDateEditableAdditionStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-start-end-date-editable-addition",
  },
)`
  position: fixed;
  width: 150px;
  height: 30px;
  top: 0;
  z-index: ${ScreenDepth.RIDE_START_END_DATE_EDITABLE};
  opacity: 0;
  display: none;
  visibility: hidden;

  // Matches the widened grid cell it is laid over.
  &.ride-start-end-date-editable-addition--ampm {
    width: 190px;
  }

  &.ride-start-end-date-editable-addition--opened {
    display: flex;
    opacity: 1;
    visibility: visible;
  }

  .ride-start-end-date-editable-addition__date-time-field {
    .MuiPickersOutlinedInput-root {
      font-size: 14px;

      &:hover,
      &.Mui-focused {
        .MuiPickersOutlinedInput-notchedOutline {
          border-color: ${blueMui._300};
        }
      }
    }

    .MuiPickersSectionList-root {
      padding-inline-start: 5px;
      padding-block: 5px;
    }
    .MuiPickersOutlinedInput-notchedOutline {
      border-color: ${blueMui._300};
      border-radius: 2px;
    }
  }
`;
